import { convertValuesToFormData } from '../../components/react-hook-form/utils/convert-values';
import { EndPointService } from '../api-handlers/axios';

const ROUTE = 'articles';

const list = (params: any) => EndPointService.get(`/${ROUTE}`, params);
const get = (id: string) => EndPointService.get(`/${ROUTE}/${id}`);
const update = (id: string, data: any) => {
    const formData =
        convertValuesToFormData({
            title: data.title,
            category: data.category.value,
            text: data.text,
            imageFile: data.imageFile[0],
        }) || {};

    return EndPointService.patch(`/${ROUTE}/${id}`, formData);
};
const create = (data: any) => {
    const formData =
        convertValuesToFormData({
            title: data.title,
            category: data.category.value,
            text: data.text,
            imageFile: data.imageFile[0],
        }) || {};

    return EndPointService.post(`/${ROUTE}/`, formData);
};
const remove = (id: string) => EndPointService.delete(`/${ROUTE}/${id}`);

export default {
    list,
    get,
    update,
    create,
    remove,
};
